import React from 'react';
import { Form } from 'react-bootstrap';

import Button from '../button/Button';

import './searchbar.css';


class SearchBar extends React.Component {
  constructor() {
    super();
    this.state = {
      search: ''
    };
  }

  // componentDidMount() {
  //   this.prefieldAllData();
  // }
  // componentDidUpdate(prevProps) {
  //   if (this.props.queryParam.selectedTab !== prevProps.queryParam.selectedTab) {
  //     this.prefieldAllData();
  //   }
  // }


  // prefieldAllData = async () => {
  //   try {
  //     const { queryParam } = this.props;
  //     // console.log('SEARCH BAR TEXT >> ', queryParam)
  //     this.setState({
  //       search: queryParam.q || ''
  //     })
  //   } catch (e) {
  //     // eslint-disable-next-line no-console
  //     // console.log(e)
  //   }
  // }

  handleInputChange = event => {
    const inputValue = event.target.value;
    const numericValue = inputValue.replace(/\D/g, '');
    this.setState({ search: numericValue });
  };

  

  submit = event => {
    event.preventDefault();
  };


  sendData = () => {

    this.props.onData(this.state.search)

  };

  render() {
    const { search, } = this.state;
    return (
      <div className='d-flex justify-content-end'>
        <Form className="d-flex my-2 sm-w-50">
          <Form.Control
            type="search"
            placeholder="Search By Journey Id"
            value={search}
            onChange={this.handleInputChange}
            className="rounded-pill"
            aria-label="Search"
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                e.preventDefault();
              }
              
            }}
          />
          <Button className='ml-1 rounded-pill' onClick={this.sendData} >
          <i class="fa fa-search font-size-18"></i>
          </Button>
        </Form>
      </div>


    );
  }
}

export default SearchBar;
